var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { Component } from 'react';
import Theme, { mediaQueries } from 'Theme';
import cxs from 'cxs/component';
var Scroll = /** @class */ (function (_super) {
    __extends(Scroll, _super);
    function Scroll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scroll.prototype.render = function () {
        return React.createElement(StyledScroll, __assign({}, this.props));
    };
    return Scroll;
}(Component));
export default Scroll;
var StyledScroll = cxs('div')((_a = {
        flex: 1,
        overflowY: 'auto',
        // overflowY: 'scroll',
        marginBottom: Theme.size.bottomButtons
    },
    _a[mediaQueries.desktop] = {},
    _a));



//////////////////
// WEBPACK FOOTER
// ./src/elements/Scroll.tsx
// module id = 1020
// module chunks = 0